
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import draggable from "vuedraggable";

// 可拖拽表单 中英枚举
const ComponentEnum = {
  params: "信息收集",
  paramsSaveLater: "后置信息收集",
  deviceDetection: "设备检测",
  certPhotoCapture: "证件照",
  livenessRecognition: "人脸核验",
  signatureConfig: "手写签名",
  faceDetection: "脸部检测",
  descBefore: "面试须知",
  questions: "AI面试官",
  colorDetection: "辨色检测",
  handDetection: "手部检测",
  tacPsycGauge: "心理测评",
  bgCheck: "背景调查",
  game: "小游戏",
  nameIdCheck: "身份信息验证",
  resumeParseConfig: "简历解析",
  bodyDetection: "形体检测"
};

@Component({
  components: {
    draggable
  }
})
export default class ComponentFlow extends Vue {
  @Prop({ default: [] }) beforeList!: any;
  @Prop({ default: [] }) afterList!: any;
  @Prop({ default: [] }) endList!: any;
  @Prop({ default: "" }) builder!: string; // 创建面试来源

  ComponentEnum = ComponentEnum;
  dragComponentListBefore: any = [];
  dragComponentListAfter: any = [];
  dragComponentListEnd: any = [];

  get showDragComponentListBefore() {
    const temp = this.dragComponentListBefore.filter(
      (item: any) => item.use === 1
    );

    // 证件照和人脸核验同时存在的时候，只需要显示一个一个条目（人脸核验+证件照）就行
    const index1 = temp.findIndex(
      (item: any) => item.name === "livenessRecognition"
    );
    const index2 = temp.findIndex(
      (item: any) => item.name === "certPhotoCapture"
    );
    if (index1 >= 0 && index2 >= 0) {
      temp[index1].hidden = true;
      ComponentEnum.certPhotoCapture = "人脸核验+证件照";
    } else {
      // 恢复设置
      ComponentEnum.certPhotoCapture = "证件照";
      const index1 = temp.findIndex(
        (item: any) => item.name === "livenessRecognition"
      );
      if (index1 >= 0) {
        temp[index1].hidden = false;
      }
    }
    return temp;
  }

  get showDragComponentListEnd() {
    return this.dragComponentListEnd.filter((item: any) => item.use === 1);
  }

  @Watch("beforeList", { deep: true, immediate: true })
  updateBeforeList(val: any) {
    this.dragComponentListBefore = val;
  }

  @Watch("afterList", { deep: true, immediate: true })
  updateAfterList(val: any) {
    this.dragComponentListAfter = val;
  }

  @Watch("endList", { deep: true, immediate: true })
  updateEndList(val: any) {
    this.dragComponentListEnd = val;
  }

  onDragEnd(position: string) {
    if (position === "Before") {
      this.$emit("update:beforeList", this.dragComponentListBefore);
    } else if (position === "After") {
      this.$emit("update:afterList", this.dragComponentListAfter);
    } else if (position === "End") {
      this.$emit("update:endList", this.dragComponentListEnd);
    }

    this.$emit("dragEnd", position);
  }

  onDragStart(position: string, e: any) {
    this.$emit("dragStart");
  }

  showComp(component: any) {
    return component?.use === 1 && !component?.hidden;
  }
}
